import * as GIF from "../js/gif";
export function updateMetaInfo(metaInfo, anim) {
  metaInfo.endTime += anim.moments[anim.moments.length - 1].time
  let sPadding = anim.rawInfo.sVis.view.padding(),
    ePadding = anim.rawInfo.eVis.view.padding();
  metaInfo.maxPadding = {
    left: Math.max(metaInfo.maxPadding.left, sPadding.left, ePadding.left),
    right: Math.max(metaInfo.maxPadding.right, sPadding.right, ePadding.right),
    top: Math.max(metaInfo.maxPadding.top, sPadding.top, ePadding.top),
    bottom: Math.max(metaInfo.maxPadding.bottom, sPadding.bottom, ePadding.bottom)
  }
  metaInfo.maxViewWidth = Math.max(metaInfo.maxViewWidth, anim.rawInfo.sVis.view._viewWidth, anim.rawInfo.eVis.view._viewWidth)
  metaInfo.maxViewHeight = Math.max(metaInfo.maxViewHeight, anim.rawInfo.sVis.view._viewHeight, anim.rawInfo.eVis.view._viewHeight)
  return metaInfo;
}
export async function recordGif(anim, opt = {}) {

  const DOMURL = window.URL || window.webkitURL || window;

  const metaInfo = {
    endTime: 0,
    maxPadding: {left:0, right: 0, top: 0, bottom: 0},
    maxViewWidth: 0, maxViewHeight: 0
  };

  if (anim.animations) {
    anim.animations.forEach(_anim => {
      updateMetaInfo(metaInfo, _anim)
    })
  } else {
    updateMetaInfo(metaInfo, anim);
  }

  const maxWidth = metaInfo.maxViewWidth + metaInfo.maxPadding.left + metaInfo.maxPadding.right;
  const maxHeight = metaInfo.maxViewHeight + metaInfo.maxPadding.top + metaInfo.maxPadding.bottom;

  let t_0, t_last,
    gif =  new GIF({
      workers: 4,
      quality: 1,
      dither: "FalseFloydSteinberg",
      background: "#ffffff",
      width: maxWidth,
      height: maxHeight
    }),
    done = false;

  let cb = () => {
    if (!t_0) {
      t_0 = window.performance.now();
    }

    let t = window.performance.now() - t_0;
    let delta = (t-t_last) || 1;
    let svgString = new XMLSerializer().serializeToString(document.querySelector(opt.targetElm + ' svg'));


    let svg = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
    let url = DOMURL.createObjectURL(svg);
    let img = new Image();

    img.onload = function() {
      gif.addFrame(img, {delay: delta});
    };
    img.src = url;

    if (t < metaInfo.endTime){
      t_last = t;
      window.requestAnimationFrame(cb)
    } else {
      gif.on('finished', async (blob) => {
        if (!done) {
          await this.setState({status: "ready"});
          await this.reset(opt.targetElm, this.props.sSpec);
          window.open(URL.createObjectURL(blob));
          done = true;
        }

      });
      gif.render();
    }
  }
  cb();
}
